module.exports = __webpack_public_path__ + "gonghuaTitle.09444ecf.png";